import React from 'react';

const LogoutIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.83333 21.5C2.19167 21.5 1.64236 21.2715 1.18542 20.8146C0.728472 20.3576 0.5 19.8083 0.5 19.1667V2.83333C0.5 2.19167 0.728472 1.64236 1.18542 1.18542C1.64236 0.728472 2.19167 0.5 2.83333 0.5H11V2.83333H2.83333V19.1667H11V21.5H2.83333ZM15.6667 16.8333L14.0625 15.1417L17.0375 12.1667H7.5V9.83333H17.0375L14.0625 6.85833L15.6667 5.16667L21.5 11L15.6667 16.8333Z"
      fill="#6E6E71"
    />
  </svg>
);

export default LogoutIcon;
